import { useState, useRef } from "react";
import "./editorialForms.css";

export default function TikTokForm({ data, onChange, editorialType }) {
  const [hashtags, setHashtags] = useState(data?.hashtags?.join(" ") || "");
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange({ 
          ...data, 
          videoFile: file, 
          videoFileName: file.name,
          videoPreview: reader.result 
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleHashtagsChange = (e) => {
    const value = e.target.value;
    setHashtags(value);
    const hashtagArray = value
      .split(/[\s,]+/)
      .filter((tag) => tag.startsWith("#") || tag.length > 0)
      .map((tag) => (tag.startsWith("#") ? tag : `#${tag}`));
    onChange({ ...data, hashtags: hashtagArray });
  };

  const getTypeName = () => {
    switch (editorialType) {
      case "reels":
        return "Reels";
      case "shorts":
        return "Shorts";
      default:
        return "TikTok";
    }
  };

  return (
    <div className="editorial_form tiktok_form">
      <div className="editorial_form_section">
        <label>
          Vídeo <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
          <input
            ref={fileInputRef}
            type="file"
            accept="video/*,.mp4,.mov,.avi,.mkv"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {data?.videoFileName ? (
            <div className="file_selected">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
              </svg>
              <span>{data.videoFileName}</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, videoFile: null, videoFileName: null, videoPreview: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
              </svg>
              <p>Clique para fazer upload do vídeo</p>
              <span>MP4, MOV, AVI, MKV</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Música (opcional)</label>
        <div className="editorial_form_row">
          <input
            type="text"
            placeholder="Nome da música"
            value={data?.musicTitle || ""}
            onChange={(e) => onChange({ ...data, musicTitle: e.target.value })}
          />
          <input
            type="text"
            placeholder="Artista"
            value={data?.musicArtist || ""}
            onChange={(e) => onChange({ ...data, musicArtist: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Hashtags</label>
        <input
          type="text"
          placeholder="#viral #fyp #trending"
          value={hashtags}
          onChange={handleHashtagsChange}
        />
        <span className="editorial_form_hint">
          Separe as hashtags por espaço ou vírgula
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Configurações</label>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="originalSound"
            checked={data?.isOriginalSound !== false}
            onChange={(e) =>
              onChange({ ...data, isOriginalSound: e.target.checked })
            }
          />
          <label htmlFor="originalSound">Som original</label>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
        <span>
          Para {getTypeName()}, grave vídeos verticais (9:16) de até 3 minutos
        </span>
      </div>
    </div>
  );
}
